import React from "react";
import {
  Button,
  Iconography,
  IconographySizes,
  IconographyThemes,
  Loader,
  LoaderSizes,
} from "@hid-galaxy-ui/galaxy-react";
import { useNavigate } from "react-router";
import "./StatusMessage.scss";
import { useAppSelector } from "../../../../../redux";

const StatusMessage: React.FC<{ ID: number }> = ({ ID }) => {
  const { status } = useAppSelector((state) => state.external_contract);
  const navigate = useNavigate();
  React.useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
  return (
    <div className="status-message-container">
      {status.addExternalContractLoading ? (
        <Loader variant={LoaderSizes.large} />
      ) : status.addExternalContractStatus ? (
        <>
          <Iconography
            icon="circleCheck"
            size={IconographySizes.XLarge}
            theme={IconographyThemes.Success}
          />
          <div className="message">External Contract Created</div>
          <Button
            variant="primary"
            label="Continue"
            onClick={() =>
              navigate(
                `/hid-admin/dashboard/partner-organizations/${ID}/services-and-subscriptions`,
                { state: { selectedTab: "manage-contracts" } }
              )
            }
          />
        </>
      ) : (
        <>
          <Iconography
            icon="circleXmark"
            size={IconographySizes.XLarge}
            theme={IconographyThemes.Error}
          />
          <div className="message">Something went wrong!</div>
          <Button
            variant="primary"
            label="Continue"
            onClick={() =>
              navigate(
                `/hid-admin/dashboard/partner-organizations/${ID}/services-and-subscriptions`,
                { state: { selectedTab: "manage-contracts" } }
              )
            }
          />
        </>
      )}
    </div>
  );
};

export default StatusMessage;
